<template>
  <v-card>
    <v-card-text>
      <v-container grid-list-lg>
        <v-layout nowrap align-center justify-center>
          <v-flex md10>
            <v-text-field
              label="Selecionar arquivo"
              @click="onPickFile"
              v-model="upload.fileName"
              prepend-icon="attach_file"
              clearable
              @click:clear="removeCurrentFile"
            ></v-text-field>
            <input
              ref="fileInput"
              type="file"
              style="display: none"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              @change="onFilePicked"
            />
          </v-flex>
          <v-flex md2>
            <v-btn
              color="primary"
              @click.stop="onAnalisysClick"
              :loading="loading"
              :disabled="!upload.fileObject"
              class="ma-3"
              >Analisar</v-btn
            >
          </v-flex>
        </v-layout>

        <!-- Kind of logs -->
        <v-card v-if="upload.name" class="ma-3">
          <v-card-title primary-title>
            <h3 class="headline mb-0">Arquivo</h3>
          </v-card-title>
          <v-card-text v-if="upload.name">Nome: {{ upload.name }}</v-card-text>
          <v-card-text v-if="upload.size"
            >Tamanho:
            {{ Math.round((upload.size / 1024) * 10) / 10 }}
            KB</v-card-text
          >
          <v-card-text v-if="upload.type">Tipo: {{ upload.type }}</v-card-text>
          <v-card-text v-if="upload.lastModifiedDate"
            >Modificado em: {{ upload.lastModifiedDate }}</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" flat @click="removeCurrentFile">
              Remover
            </v-btn>
            <v-btn
              color="success"
              flat
              :loading="loading"
              @click.stop="uploadNewReport"
            >
              Enviar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-container>
    </v-card-text>

    <v-snackbar :color="snack.color" top v-model="snack.show" dark>
      <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
      <div>{{ snack.message }}</div>
      <v-icon size="16" @click="snack.show = false"> mdi-close-circle </v-icon>
    </v-snackbar>
  </v-card>
</template>

<script>
import dayjs from "dayjs";
import { mapMutations } from "vuex";
import { uploadNewNeoenergiaReport } from "../../services/billing";

export default {
  name: "sheet-upload",

  data() {
    return {
      loading: false,
      upload: {
        fileObject: null,
        fileName: "",
        url: "",
        name: "",
        size: "",
        type: "",
        lastModifiedDate: "",
      },
      snack: {
        show: false,
        color: "",
        message: "",
      },
    };
  },

  methods: {
    ...mapMutations("reports", ["setLoading"]),

    onPickFile() {
      this.$refs.fileInput.click();
    },

    onFilePicked(event) {
      const files = event.target.files;
      if (files[0] !== undefined) {
        this.upload.fileName = files[0].name;

        if (this.upload.fileName.lastIndexOf(".") <= 0) {
          return;
        }

        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          this.upload.url = fr.result;
          this.upload.fileObject = files[0];
        });
      } else {
        return;
      }
    },

    async onAnalisysClick() {
      this.loading = true;

      if (!this.upload.fileObject) {
        this.loading = false;
        return;
      }

      this.upload.name = this.upload.fileObject.name;
      this.upload.size = this.upload.fileObject.size;
      this.upload.type = this.upload.fileObject.type;

      this.upload.lastModifiedDate =
        dayjs(this.upload.fileObject.lastModifiedDate).format(
          "DD/MM/YYYY HH:mm:ss",
        ) ?? "";
      this.loading = false;
    },

    removeCurrentFile() {
      this.$refs.fileInput.value = null;
      Object.assign(this.$data, this.$options.data.apply(this));
    },

    async convertFileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          const base64String = reader.result.split(",")[1];
          resolve(base64String);
        };
        reader.onerror = (error) => reject(error);
      });
    },

    async uploadNewReport() {
      try {
        this.loading = true;
        const converted_file = await this.convertFileToBase64(
          this.upload.fileObject,
        );

        const response = await uploadNewNeoenergiaReport({
          file: converted_file,
        });

        this.removeCurrentFile();
        this.loading = false;
        this.showSnackBar(response.data.message, "green");
      } catch (error) {
        console.error(error);
        this.removeCurrentFile();
        this.loading = false;
        if (error.response?.data?.message) {
          return this.showSnackBar(
            "Erro ao fazer o upload: " + error.response?.data?.message,
            "red",
          );
        }
        this.showSnackBar(
          "Erro ao fazer o upload. Contate o time de tecnologia",
          "red",
        );
      }
    },

    showSnackBar(message, color) {
      this.snack.color = color;
      this.snack.message = message;
      this.snack.show = true;
    },
  },
};
</script>
